import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  right: 22px;\n  transition: all 0.3s;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext } from "react";
import styled from "styled-components";
import { MenuContext } from "../../widgets/Menu/context";
import { Flex } from "../Box";
import AnimatedIconComponent from "../Svg/AnimatedIconComponent";
import { StyledBottomNavItem, StyledBottomNavText } from "./styles";
import { ArrowGradientIcon } from "../Svg";
var ArrowWrapper = styled.div.withConfig({
    componentId: "sc-2ac5c49e-0"
})(_templateObject());
var BottomNavItem = function(_param) {
    var label = _param.label, icon = _param.icon, fillIcon = _param.fillIcon, href = _param.href, _showItemsOnMobile = _param.showItemsOnMobile, showItemsOnMobile = _showItemsOnMobile === void 0 ? false : _showItemsOnMobile, _isActive = _param.isActive, isActive = _isActive === void 0 ? false : _isActive, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, isBottomMenuOpen = _param.isBottomMenuOpen, props = _object_without_properties(_param, [
        "label",
        "icon",
        "fillIcon",
        "href",
        "showItemsOnMobile",
        "isActive",
        "disabled",
        "isBottomMenuOpen"
    ]);
    var linkComponent = useContext(MenuContext).linkComponent;
    var toLink = function() {
        window.localStorage.removeItem("isShowPopup");
    };
    var bottomNavItemContent = /*#__PURE__*/ _jsxs(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        children: [
            icon && /*#__PURE__*/ _jsx(AnimatedIconComponent, {
                icon: icon,
                fillIcon: fillIcon,
                height: "22px",
                width: "21px",
                color: isActive ? "#51D1B8" : "textMenuMobile",
                isActive: isActive,
                activeBackgroundColor: "backgroundAlt"
            }),
            /*#__PURE__*/ _jsx(StyledBottomNavText, {
                color: isActive ? "#51D1B8" : "textMenuMobile",
                $isActive: isActive,
                fontWeight: isActive ? "600" : "400",
                fontSize: "16px",
                children: label
            }),
            href !== "/farms" ? /*#__PURE__*/ _jsx(_Fragment, {}) : /*#__PURE__*/ _jsx(ArrowWrapper, {
                style: {
                    transform: isBottomMenuOpen ? "rotate(0deg)" : "rotate(180deg)"
                },
                children: /*#__PURE__*/ _jsx(ArrowGradientIcon, {
                    width: "18px"
                })
            })
        ]
    });
    return showItemsOnMobile ? /*#__PURE__*/ _jsx(StyledBottomNavItem, _object_spread_props(_object_spread({
        $isActive: isBottomMenuOpen,
        style: {
            opacity: disabled ? 0.5 : 1
        },
        type: "button"
    }, props), {
        children: bottomNavItemContent
    })) : /*#__PURE__*/ _jsx(StyledBottomNavItem, _object_spread_props(_object_spread({
        style: {
            opacity: disabled ? 0.5 : 1
        },
        as: linkComponent,
        href: href
    }, props), {
        onClick: toLink,
        children: bottomNavItemContent
    }));
};
export default BottomNavItem;
